// Templates list page (CHG-1261 / ITER-3386).
//
// Thin per the v12 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates templateListConfig
// from template.entity-hint.yaml (CHG-1235) without touching this file.
//
// Spec: specs/tier-05-experience/templates-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { templateListConfig } from "../generated/screens/template-list";

export function Templates() {
  return <ListPage config={templateListConfig} />;
}
